import '../instagram/instagram_text_dm_content.js.coffee'
import '../instagram/instagram_image_dm_content.js.coffee'
import '../instagram/instagram_like_dm_content.js.coffee'
import '../instagram/instagram_reel_share_dm_content.js.coffee'
import '../instagram/instagram_unsupported_dm_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramDMContentFactory
  types:
    text: Monitoring.Models.SocialContents.InstagramTextDMContent
    media: Monitoring.Models.SocialContents.InstagramImageDMContent
    like: Monitoring.Models.SocialContents.InstagramLikeDMContent
    reel_share: Monitoring.Models.SocialContents.InstagramReelShareDMContent

  create: (socialContent) =>
    type = @types[socialContent?.content?.item_type]
    if type
      new type(socialContent)
    else
      new Monitoring.Models.SocialContents.InstagramUnsupportedDMContent(socialContent)
